// Generated by Melange

import AlbumCardModuleCss from "./albumCard.module.css";
import * as ReactRouter from "@tanstack/react-router";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Router__Link from "../router/link.jsx";
import * as Shared__CoverArt from "./coverArt.jsx";
import * as Shared__Skeleton from "./skeleton.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Context from "../store/context.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = AlbumCardModuleCss;

function AlbumCard(Props) {
  let coverArtSizes = Props.coverArtSizes;
  let id = Props.id;
  let loadCoverArtLazily = Props.loadCoverArtLazily;
  const album = Store__Context.useAppStore(function (state) {
    return Stdlib__Option.bind(id, (function (id) {
      return Caml_option.undefined_to_opt(state.albums.baseById.get(id));
    }));
  });
  let tmp = {};
  const tmp$1 = Stdlib__Option.map((function (x) {
    return x.coverArt;
  }), album);
  if (tmp$1 !== undefined) {
    tmp.coverArt = Caml_option.valFromOption(tmp$1);
  }
  if (loadCoverArtLazily !== undefined) {
    tmp.lazy = Caml_option.valFromOption(loadCoverArtLazily);
  }
  if (coverArtSizes !== undefined) {
    tmp.sizes = Caml_option.valFromOption(coverArtSizes);
  }
  const arg = JsxRuntime.jsx(Shared__Skeleton.make, {
    style: {
      width: "6rem"
    }
  });
  const arg$1 = JsxRuntime.jsx(Shared__Skeleton.make, {
    style: {
      width: "4rem"
    }
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, Caml_option.some(JsxRuntime.jsxs(React.Fragment, {
        children: [
          JsxRuntime.jsx(Shared__CoverArt.make, tmp),
          JsxRuntime.jsx("h2", {
            children: (function (param) {
              return Stdlib__Option.value(param, arg);
            })(Stdlib__Option.map((function (album) {
              return album.name;
            }), album)),
            className: css.name
          })
        ]
      })), css.link, undefined, undefined, {
        albumId: id
      }, undefined, "/album/$albumId", undefined)),
      JsxRuntime.jsx("div", {
        children: (function (param) {
          return Stdlib__Option.value(param, arg$1);
        })(Stdlib__Option.map((function (album) {
          const arg = null;
          return JsxRuntime.jsxs(React.Fragment, {
            children: [
              (function (param) {
                return Stdlib__Option.value(param, arg);
              })(Stdlib__Option.map((function (year) {
                return JsxRuntime.jsxs(React.Fragment, {
                  children: [
                    JsxRuntime.jsx("time", {
                      children: year
                    }),
                    " – "
                  ]
                });
              }), album.year)),
              JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, Caml_option.some(album.artist), undefined, undefined, undefined, {
                artistId: album.artistId
              }, undefined, "/artist/$artistId", undefined))
            ]
          });
        }), album)),
        className: css.info
      })
    ],
    className: css.root
  });
}

const make = React.memo(AlbumCard);

export {
  make,
}
/* css Not a pure module */
